<template>
  <div class="OpenExpertView">
    <div class="fix-top-section">
      <Retailnavbar style="position: fixed; top: 0; width: 100%; z-index: 5"></Retailnavbar>

      <LivePriceTickerVue></LivePriceTickerVue>
      <!-- Banner Image -->
      <div class="banner-section">
        <!-- <img v-if="currentEnvironment.utm_source == 'Supernal Ventures'" src="../assets/images/OfferBanner.svg" class="offer-img-mob" alt="" /> -->
        <ChatBannerComponent class="chat-banner banner-desktop"></ChatBannerComponent>
        <!-- <ChatBannerComponent class="banner-mobile chat-banner"></ChatBannerComponent> -->
      </div>
    </div>
    <OpenRecoCard></OpenRecoCard>

    <StockSectionCarousel></StockSectionCarousel>

    <SectorsCovered></SectorsCovered>

    <LoginSectionComponent></LoginSectionComponent>

    <RetailFooter class="footer"></RetailFooter>
  </div>
</template>
  
  <script>
import RetailFooter from '@/components/RetailSideCompo/RetailFooter.vue';
import Retailnavbar from '@/components/RetailSideCompo/RetailNavbar.vue';
import ChatBannerComponent from '@/components/ChatBannerComponent.vue';
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import OpenRecoCard from '../components/OpenRecoCard.vue';
import StockSectionCarousel from '../components/StockSectionCarousel.vue';
import SectorsCovered from '../components/SectorsCovered.vue';
import LoginSectionComponent from '../components/loginSectionComponent.vue';

export default {
  name: 'OpenExpertView',
  components: { RetailFooter, Retailnavbar, ChatBannerComponent, LivePriceTickerVue, OpenRecoCard, StockSectionCarousel, SectorsCovered, LoginSectionComponent },

  data() {
    return {};
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('profile') && !Object.keys(to.query).length) {
      next('/data-categorisation'); // Redirect using next
    } else {
      next(); // Continue with the navigation
    }
  },
  beforeCreate() {
    // get currentEnvironment details
    if (!localStorage.getItem('profile')) {
      setTimeout(() => {
        if (localStorage.getItem('currentEnvironment')) {
          var currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

          if (currentEnvironment.utm_source && (currentEnvironment.utm_source == 'Nirman' || currentEnvironment.utm_source == 'Choice')) {
            this.$router.push('/');
          } else if (currentEnvironment.byPassLogin) {
            this.$router.push('/auth-bypass');
          }
        }
      }, 0);
    }
  },
};
</script>
  
<style scoped lang="scss">
.OpenExpertView {
  background-color: #f4f4f4;
  .fix-top-section {
    margin-bottom: 80px;
  }
  .chat-banner {
    position: relative;
    top: 99px;
    // top: 55px;
    z-index: 0;
  }
  // .footer {
  //   padding-top: 60px;
  // }

  .banner-mobile {
    display: none;
  }

  @media screen and (max-width: 727px) {
    .banner-mobile {
      display: block;
      margin-bottom: 15px;
    }
  }
}
</style>
<style  lang="scss">
.OpenExpertView {
  .footer-container {
    margin-top: 0 !important;
  }
}
</style>